import { generateRandomString } from "utility/Utils";

export function hashComponentName (componentName: string): string {
    return `[${componentName}-${generateRandomString(8)}]`;
};

export function unhashAccessPath (componentName: string): string {
    if (!componentName) {
        return "[Unknown]";
    }

    return componentName.replace(
        /\[([^\]]+)]/g,
        (match, words: string) => {
            return `[${words.split(" ").map(word => word.split("-")[0]).join(" ")}]`;
        }
    );
};
